import React from "react";
import "./TeamCard.css";
import { Link } from "react-router-dom";

function TeamCard({ name, role, description, image, target, onClick }) {
  return (
    <div className="team-card" onClick={onClick} style={{ cursor: 'pointer' }}>
      <Link to={target} className="team-card-link">
        <div className="team-card-content">
          <h3 className="team-card-name">{name}</h3>
          <p className="team-card-role">{role}</p>
          {description && <p className="team-card-description">{description}</p>}
        </div>
      </Link>
    </div>
  );
}

export default TeamCard;